import { fetchTypes } from "../../services/api";
export default {
  namespaced: true,
  state: {
    all: [],
  },
  getters: {
      getAll(state) {
        return state.all;
      },
     mappedById: (state) => {
       return state.all.reduce((total, type) => {
         total[type.id] = type;
         return total;
       }, {});
     },
    current: (state, getters, rootState) => {
      return getters.mappedById[rootState.build.type] ? getters.mappedById[rootState.build.type] : null;
    },
    // methodsById: (state, getters, rootState) => {
    //   let type = getters.mappedById[rootState.build.type];
    //   if(!type) return {};
    //   return type.methods.reduce((total, method) => {
    //     total[method.id] = method;
    //     return total;
    //   }, {});
    // },

    /**
     * Get the property (field) from your current type
     * eg: name: methods, id: 1, field: price
     *
     * @param state
     * @param getters
     * @param rootState
     *
     * returns field value, property or null
     */
    chosenProperty:  (state, getters) => (name, id, field) => {
      let type = getters.current;
      if(!type) return null;

      if (type[name] === undefined) return null;

      let object = type[name].find((a) => {
        return a.id === id
      });

      if (object && field) {
        return object[field];
      } else if (object) {
        return object;
      } else {
        return null;
      }
    },
  },
  actions: {
    fetch: ({ commit, rootState }) => {
      return fetchTypes(rootState.environmentId).then(({ data }) => {
        commit('SET_TYPES', data);
      });
    },
  },
  mutations: {
    SET_TYPES: (state, data) => {
      state.all = data;
    },
  },
};
